var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"networkError text-center"},[_c('h1',[_vm._v("Uh-Oh!")]),_c('h3',[_vm._v("It looks like you are not logged in. Try to login again.")]),_c('v-btn',{staticClass:"call-btn",attrs:{"elevation":"2","outlined":"","to":{ name: 'LoginBasic' }}},[_vm._v("Log in to PACall Ops")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }